import React, { useState } from "react"
import { useParams } from "react-router-dom"
import AuthService from '../services/authentication'
import { useMixture } from '../data/mixture'
import ProductSearchIndex from "../products/ProductSearchIndex"
import MixtureSummary from "./MixtureSummary"
import MaxProductsModal from "./MaxProductsModal"

function MixtureIndex() {
	const auth = AuthService.useAuth()
	const { id } = useParams()
	const [displayMaxProductsPopup, setDisplayMaxProductsPopup] = useState(false)
	const { mixture, isLoading, isError, addLineItem } = useMixture(id, auth.authHeader())

	if (isLoading) return <div>Loading...</div>
	if (isError) return <div>Error loading mixture</div>

	const onAddToOrder = product => {
		if (mixture.sales_order_items.length < 10) {
			addLineItem(product)
		} else {
			setDisplayMaxProductsPopup(true)
		}
	}

	return (
		<>
		<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
		  <div className="order-2 md:order-1">
		    <ProductSearchIndex
         onOrderAddition={onAddToOrder}
         variant="mixture"
				 mixtureId={id}
		    />
		  </div>
		  <div className="order-1 md:order-2 mb-4">
		    <MixtureSummary id={id} />
		  </div>
		</div>
		<MaxProductsModal
			show={displayMaxProductsPopup}
			onHide={() => setDisplayMaxProductsPopup(false)}
		/>
		</>
	)
}

export default MixtureIndex
